import { useState, useEffect, useCallback } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { BsCheck } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DAILYTARGET, BMIPROGRESSION } from '../../helpers/Constant';
import moment from 'moment';
import { getUserType } from '../../utils/common';
import { postDataWithToken } from '../../api/api';

export default function DailyTarget({ userData, dailyTarget, dailyBurned, dailyTargetPercentage }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userType = getUserType();
    const [weekDates, setWeekDates] = useState([]);
    const currentDate = moment().format('MMMM, YYYY');

    const checkStreakSaverUsed = (date) => {
        if(userData?.userStreaks?.streakUsed && userData?.userStreaks?.streakUsed !== undefined && userData?.userStreaks?.streakUsed !== null) {
            for(let i = 1; i <= 7; i++) {
                if(userData?.userStreaks?.streakUsed[i] && userData?.userStreaks?.streakUsed[i] !== undefined && userData?.userStreaks?.streakUsed[i] !== null && userData?.userStreaks?.streakUsed[i] === date) {
                    return true;
                }
            }
        }
        return false;
    }

    const getWeekDatesBmi = useCallback(async () => {
        const currentDate = moment().startOf('week');
        const endOfWeek = moment().endOf('week');
        const current = moment().format('D');
        const dates = [];
        let sumOfBurned = {};
        let sumOfTarget = {};

        let bmiData = {
            "datePeriod": "Month",
            "date": currentDate.format('MM/DD/YYYY')
        };

        if (userType && userType !== 'guest_user') {
            const bmiProgressionData = await postDataWithToken(BMIPROGRESSION, bmiData);

            if (bmiProgressionData.status === 200) {
                if (bmiProgressionData.data.length > 0) {
                    sumOfBurned = bmiProgressionData.data[0].sumOfBurned;
                    sumOfTarget = bmiProgressionData.data[0].sumOfTarget;
                }
            }
        }

        while (currentDate <= endOfWeek) {
            var date = currentDate.format('D');
            var average = 0;
            if (sumOfBurned && sumOfBurned[date] && sumOfTarget && sumOfTarget[date]) {
                average = ((sumOfBurned[date] / sumOfTarget[date]) * 100).toFixed(2);
            }

            dates.push({
                day: currentDate.format('dddd')[0],
                date: currentDate.format('DD'),
                selected: (current === date) ? 'day_selected' : '',
                average: average,
                streakSaver: checkStreakSaverUsed(currentDate.format('YYYY-MM-DD'))
            });
            currentDate.add(1, 'day');
        }
        setWeekDates(dates);
    }, [userType]);

    useEffect(() => {
        getWeekDatesBmi();
    }, [userType]);


    return (
        <div className='reward_wrapper position-relative bg-primary rounded-corners p-12' onClick={() => navigate(`/${DAILYTARGET}`)} >
            <FiArrowUpRight className='position-absolute text-light end-0 top-0 mt-2 me-2' />
            <h6 className='text-white opacity-75 fs-6 fw-bold mb-0 d-inline'>{t('Daily Target')}</h6>
            <div className='d-flex align-items-center flex-wrap mb-2'>
                <div className='d-flex justify-content-between align-items-end my-2 w-100'>
                    <div className='d-flex align-items-center '>
                        <img src='../images/fireicon.svg' height={30} alt='fireicon' />
                        <h2 className='ps-2 fw-bold text-light mb-0'><span className='text-warning text_shadow_green'>{dailyBurned}</span> / {(Math.round(dailyTarget)).toFixed(0)}</h2>
                    </div>
                    <h2 className='text-white fw-bold mb-0 opacity-75'>{(isNaN(dailyTargetPercentage) || dailyTargetPercentage === 0) ? 0 : dailyTargetPercentage}%</h2>
                </div>
                <div className='progressbar_track position-relative mb-4 bg-light w-100'>
                    <div className='progressbar_thumb position-absolute start-0 top-0 bottom-0 bg-warning mw-100 rounded-1' style={{ width: dailyTargetPercentage + '%' }}></div>
                    <div className={`reward_divider position-absolute d-flex align-items-center ${dailyTargetPercentage <= 25 ? 'reward_pending step_1' : 'reward_done_step_1'}`}>
                        <span className='d-flex align-items-center justify-content-center rounded-circle point_icon'>{dailyTargetPercentage >= 25 ? < BsCheck color='black' /> : ''}</span>
                        {dailyTargetPercentage <= 25 ? <span className='mb-0 text-white point_number'>50</span> : ''}
                    </div>
                    <div className={`reward_divider position-absolute d-flex align-items-center ${dailyTargetPercentage <= 50 ? 'reward_pending step_2' : 'reward_done_step_2'}`}>
                        <span className='d-flex align-items-center justify-content-center rounded-circle point_icon'>{dailyTargetPercentage >= 50 ? < BsCheck color='black' size={20} /> : ''}</span>
                        {dailyTargetPercentage <= 50 ? <span className='mb-0 text-white point_number'>50</span> : ''}
                    </div>
                    <div className={`reward_divider position-absolute d-flex align-items-center ${dailyTargetPercentage <= 75 ? 'reward_pending step_3' : 'reward_done_step_3'}`}>
                        <span className='d-flex align-items-center justify-content-center rounded-circle point_icon'>{dailyTargetPercentage >= 75 ? < BsCheck color='black' size={20} /> : ''}</span>
                        {dailyTargetPercentage <= 75 ? <span className='mb-0 text-white point_number'>50</span> : ''}
                    </div>
                    <div className={`reward_divider position-absolute d-flex align-items-center ${dailyTargetPercentage < 100 ? 'reward_pending step_4' : 'reward_done_step_4'}`}>
                        <span className='d-flex align-items-center justify-content-center rounded-circle point_icon'>{dailyTargetPercentage >= 100 ? < BsCheck color='black' /> : ''}</span>
                        {dailyTargetPercentage < 100 ? <span className='mb-0 text-white point_number'>50</span> : ''}
                    </div>
                </div>
            </div>
            <div className='daily_reward pt-2'>
                <h5 className='text-white ps-2 opacity-75'>{currentDate}</h5>
                <div className='d-flex justify-content-around'>
                    {weekDates ? (<>
                        {
                            weekDates.map((item, index) => {
                                return (
                                    <div className={`day reward_collected text-center position-relative ${item['selected']} ${item['streakSaver'] ? 'day_streak_saver' : ''}`} key={index}>
                                        <div className='date d-flex align-items-center justify-content-center bg-transparent rounded-circle position-relative'
                                            role="progressbar"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                            style={{ '--value': `${item['average']}` }}>
                                            <p className='my-0 position-relative fw-semibold day_name opacity-75 text-white'>{item['date']}</p>
                                        </div>
                                        <p className='day_name position-relative fw-semibold mb-1'>{item['day']}</p>
                                    </div>
                                )
                            })
                        }
                    </>) : null}
                </div>
            </div>
        </div>
    )
}